export const rooferCategoryIds = [
  1189, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608,
  1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640,
  1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052, 2032,
  2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041, 2039,
  2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1199, 1543, 1505, 1697,
  1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528,
  1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197,
  2055, 2038, 2046, 2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054,
  2051, 2056, 2034, 2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542,
  1244, 2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633,
  1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193,
  1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052,
  2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041,
  2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1199, 1543, 1505,
  1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415, 1192,
  1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717,
  1197, 2055, 2038, 2046, 2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042, 2045,
  2054, 2051, 2056, 2034, 2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047, 2053,
  1542, 1244, 2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541,
  1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200,
  1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049,
  2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036,
  2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1199, 1543,
  1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415,
  1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196,
  1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042,
  2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047,
  2053, 1542, 1244, 2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506,
  1541, 1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380,
  1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048,
  2049, 2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035,
  2036, 2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1545,
  1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454,
  1190, 1196, 1717, 1197, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541,
  1633, 1608, 1194, 1542, 1244, 2047, 2053, 2048, 2049, 2052, 2038, 2051, 2039,
  2040, 2046, 2032, 2037, 2034, 2035, 2044, 2050, 2055, 2042, 2033, 2043, 2045,
  2054, 2056, 2036, 2041, 2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242,
  1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615,
  1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046,
  2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034,
  2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936,
  1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545,
  1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454,
  1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052, 2032, 2037, 2044,
  2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041, 2039, 2040, 2033,
  2043, 2047, 2053, 1542, 1244, 2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195,
  1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616,
  1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038,
  2046, 2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056,
  2034, 2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066,
  1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194,
  1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455,
  1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052, 2032, 2037,
  2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041, 2039, 2040,
  2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1199, 1543, 1505, 1697, 1198,
  1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191,
  1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055,
  2038, 2046, 2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051,
  2056, 2034, 2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244,
  2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608,
  1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640,
  1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052, 2032,
  2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041, 2039,
  2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1199, 1543, 1505, 1697,
  1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528,
  1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197,
  2055, 2038, 2046, 2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054,
  2051, 2056, 2034, 2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542,
  1244, 2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633,
  1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193,
  1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052,
  2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041,
  2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1545, 1702, 1415,
  1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196,
  1717, 1197, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608,
  1194, 1542, 1244, 2047, 2053, 2048, 2049, 2052, 2038, 2051, 2039, 2040, 2046,
  2032, 2037, 2034, 2035, 2044, 2050, 2055, 2042, 2033, 2043, 2045, 2054, 2056,
  2036, 2041, 2066, 1936, 1199, 1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541,
  1633, 1608, 1194, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615, 1380, 1200,
  1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197, 2055, 2038, 2046, 2048, 2049,
  2052, 2032, 2037, 2044, 2050, 2042, 2045, 2054, 2051, 2056, 2034, 2035, 2036,
  2041, 2039, 2040, 2033, 2043, 2047, 2053, 1542, 1244, 2066, 1936, 1199, 1543,
  1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702, 1415,
  1192, 1528, 1191, 1616, 1615, 1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196,
  1717, 1197, 2055, 2038, 2046, 2048, 2049, 2052, 2032, 2037, 2044, 2050, 2042,
  2045, 2054, 2051, 2056, 2034, 2035, 2036, 2041, 2039, 2040, 2033, 2043, 2047,
  2053, 1542, 1244, 2066, 1936, 1545, 1702, 1415, 1192, 1528, 1191, 1616, 1615,
  1380, 1200, 1193, 1640, 1455, 1454, 1190, 1196, 1717, 1197, 1199, 1543, 1505,
  1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1542, 1244, 2047, 2053,
  2048, 2049, 2052, 2038, 2051, 2039, 2040, 2046, 2032, 2037, 2034, 2035, 2044,
  2050, 2055, 2042, 2033, 2043, 2045, 2054, 2056, 2036, 2041, 2066, 1936, 1199,
  1543, 1505, 1697, 1198, 1195, 1242, 1506, 1541, 1633, 1608, 1194, 1545, 1702,
  1415, 1192, 1528, 1191,
];
